import { render, staticRenderFns } from "./Placing.vue?vue&type=template&id=059e4de9&scoped=true&"
import script from "./Placing.vue?vue&type=script&lang=js&"
export * from "./Placing.vue?vue&type=script&lang=js&"
import style0 from "./Placing.vue?vue&type=style&index=0&id=059e4de9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059e4de9",
  null
  
)

component.options.__file = "Placing.vue"
export default component.exports